
import { Component } from "vue-property-decorator";
import HospitalHeader from "@/components/HospitalHeader.vue";
import ManagementFooter from "@/components/ManagementFooter.vue";
import Button from "@/components/Button.vue";
import { CourseData, CourseDetail, CourseDay } from "@/@types/course";
import FacilityService from "@/services/facilities";
import FacilityModule from "@/store/facility";
import CheckCommonLogin from "@/utils/CheckCommonLogin";
import { deleteNullProp } from "@/utils/Util";
import _ from "lodash";

@Component({
  name: "CourseMessageSetting",
  components: {
    HospitalHeader,
    ManagementFooter,
    Button,
  },
})
export default class CourseMessageSetting extends CheckCommonLogin {
  private saveSuccess = false;
  private saveError = false;
  private loading = false;
  private course: CourseData | null = null;
  private isMessageRequired = false;

  private get hospitalId() {
    return FacilityModule.hospitalId;
  }

  private get courseId(): string {
    return this.$route.params.courseId;
  }

  private async mounted() {
    await this.fetchCourse();
  }

  private async fetchCourse() {
    try {
      const res = await FacilityService.getCourses(this.hospitalId);
      const courses: CourseData[] = res.data.data;
      this.course = courses.find((c) => c.id === this.courseId) ?? null;
      if (this.course) {
        this.isMessageRequired = this.course.is_message_required ?? false;
      }
    } catch (e) {
      console.error(e);
    }
  }

  private normalizeHolidayPrimary(detail: CourseDetail) {
    if (!detail.days.length) return;
    const holidayDay = detail.days.find((day: CourseDay) => day.available_days.includes("Holiday"));
    const normalizedValue = holidayDay?.is_holiday_primary ?? detail.days[0].is_holiday_primary ?? true;
    detail.days.forEach((day: CourseDay, index: number) => {
      this.$set(detail.days[index], "is_holiday_primary", normalizedValue);
    });
  }

  private async save() {
    if (!this.course) return;
    this.loading = true;
    this.saveError = false;
    try {
      const payload = deleteNullProp(_.cloneDeep(this.course));
      payload.is_message_required = this.isMessageRequired;
      payload.details.forEach((detail: CourseDetail) => {
        this.normalizeHolidayPrimary(detail);
      });
      payload.details.forEach((detail: CourseDetail) => {
        if (detail.period.is_end_date) {
          delete detail.period.end_date;
          delete detail.period.end_month;
          delete detail.period.end_year;
        }
        delete detail.period.is_end_date;
      });
      await FacilityService.updateCourse(this.hospitalId, this.course.id, payload);
      this.saveSuccess = true;
      setTimeout(() => {
        this.saveSuccess = false;
        this.toCourseSetting();
      }, 2000);
    } catch (e) {
      this.saveError = true;
    } finally {
      this.loading = false;
    }
  }

  private toCourseSetting() {
    this.$router.push({ name: "CourseSetting" });
  }
}
